import toast from "react-hot-toast";

import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  DistanceCountPayloadType,
  SingleColumnType,
  UpdateEWayBillPayloadType,
  UpdateTrasporterEWayBillPayloadType,
} from "./invoicingAdvance-types";
import FileSaver from "file-saver";

import {
  addInvoicingAdvanceApi,
  downloadInvoicingAdvanceReportsApi,
  getAllExpensesInvoicesListApi,
  getAllMappedClientColumnListApi,
  getInvoiceHistoryApi,
  invoicingAdvanceGetComment,
  invoicingAdvancePostCommentApi,
  invoicingAdvanceLockEntryApi,
  postInvoicingAdvanceOCRApi,
  getSingleInvoiceEntryApi,
  invoiceApprovalApi,
  invoiceDownloadDetailsApi,
  deleteInvoiceEntryApi,
  updateInvoicingAdvanceApi,
  getBulkUploadHistoryDataApi,
  bulkUploadOtherApi,
  bulkUploadExpensesApi,
  bulkUploadRevenueApi,
  bulkUploadOtherSuspenseApi,
  ReviewEWayBillApi,
  generateEWayBillApi,
  eWayBillCancelApi,
  extendEWayBillApi,
  checkDistanceCountApi,
  eWayBillAuthenticationPostApi,
  updateTransporterEWayBillDetailsApi,
  updateVehicleEWayBillDetailsApi,
  checkDuplicateInvoiceEntryApi,
  getAllOtherInvoicesListApi,
  deleteOtherInvoiceApi,
  getOthersInvoiceHistoryApi,
  sendOverdueEmailApi,
  addOtherInvoiceGenerationApi,
  getSingleOtherInvoiceDetailsApi,
  updateOtherInvoiceApi,
  downloadOthersReportsApi,
  getGstr2a2bComparePayloadApi,
  getUploadedBankStatementApi,
  getAllPaymentLedgersListApi,
  getAllBusinessAddressesApi,
  uploadBankStatementApi,
  getUploadedBankStatementTransactionApi,
  allocateBankTransactionToOtherInvoiceApi,
  postMultipleBankTransactionApi,
  getUploadedBankStatementTransactionCommentApi,
  postTransactionCommentApi,
  refreshBankStatementSuggestionsApi,
  bankStatementTransactionFileUploadApi,
  getOverdueInvoiceReminderEmailTimeline,
  lockUnlockInvoiceApi,
} from "@/components/InvoicingAdvance/apis/invoicingAdvance-api";
import {
  AddCommentPayloadType,
  AddInvoicingAdvanceApiPayloadType,
  BankStatementTransactionFileUploadPayload,
  BulkUploadApiType,
  CreateOthersInvoiceAndAllocatePayload,
  DeleteInvoiceEntryPayloadType,
  DeleteOtherInvoicesApiPayloadType,
  DownloadInvoicingAdvanceReportsApiPayloadType,
  DownloadOthersReportsApiPayloadType,
  DuplicateEntriesPayloadType,
  EinvoiceAuthenticationDataPayloadType,
  EWayBillCancelPayloadType,
  ExtendEWayBillPayloadType,
  GenerateEWayBillPayloadType,
  GetAllBusinessAddressesApiPayloadType,
  GetAllExpensesInvoicesListPayloadType,
  GetAllMappedClientColumnsApiPayloadType,
  GetAllOtherInvoicesListApiPayloadType,
  GetBankStatementsTransactionsCommentListPayload,
  GetBankStatementsTransactionsListPayload,
  GetBulkUploadHistoryPayloadType,
  GetGstrTwoATwoBInvoicePayload,
  GetSingleInvoiceEntryApiPayloadType,
  GetSingleOtherInvoiceDetailsPayloadType,
  GetUploadedBankStatementPayload,
  InvoiceHistoryPayloadType,
  InvoiceOverdueEmailTimelinePayload,
  InvoicingAdvanceLockEntryApiPayloadType,
  LockUnlockInvoicePayloadType,
  OtherHistoryPayloadApiType,
  PostInvoicingAdvanceOCRApiPayloadType,
  PostMultipleBankTransactionPayload,
  PostTransactionsCommentListPayload,
  RefreshBankStatementSuggestionsPayload,
  ReviewEWayBillPayloadApi,
  SendOverdueEmailPayloadApiType,
  UpdateInvoicingAdvanceApiPayloadType,
  UploadBankStatementPayload,
} from "@/components/InvoicingAdvance/apis/invoicingAdvanceApis-type";
import { GetCommentApiType } from "@/components/InvoicingAdvance/apis/invoicingAdvanceApis-type";
import { checkComparison } from "@/components/InvoicingAdvance/helpers/invoicingAdvance-functions";
import {
  AddOtherInvoiceApiPayloadType,
  ApproveInvoiceApiPayloadType,
  UpdateOtherInvoiceApiPayloadType,
} from "@/components/InvoicingAdvance/helpers/invoicingAdvance-type";

import { GetAllLedgersListPayloadType } from "@/commonTypes/clientSettingsTypes";

// also used to fetch revenue list as well
export const getAllExpensesInvoicesListAction = createAsyncThunk(
  "invoicingAdvance/getAllExpensesInvoicesList",
  async (data: GetAllExpensesInvoicesListPayloadType) => {
    const response = await getAllExpensesInvoicesListApi(data);
    return { data: response.data, offset: data.params.offset };
  }
);

export const getInvoiceAllCommentAction = createAsyncThunk(
  "/invoicingAdvance/customer/invoice/comments",
  async (data: GetCommentApiType) => {
    const response = await invoicingAdvanceGetComment(data);
    return response.data;
  }
);

export const postInvoiceAllCommentAction = createAsyncThunk(
  "/invoicingAdvance/add/customer/invoice/comments",
  async (data: AddCommentPayloadType) => {
    const response = await invoicingAdvancePostCommentApi(data);
    return response.data;
  }
);

export const getInvoiceHistoryDataAction = createAsyncThunk(
  "invoicingAdvance/history/invoice",
  async (data: InvoiceHistoryPayloadType) => {
    const response = await getInvoiceHistoryApi(data);
    return { data: response.data, offset: data.params.offset };
  }
);

export const downloadInvoicingAdvanceReportsAction = createAsyncThunk(
  "invoicingAdvance/downloadReports",
  async (
    data: DownloadInvoicingAdvanceReportsApiPayloadType,
    { rejectWithValue }
  ) => {
    try {
      const response = await downloadInvoicingAdvanceReportsApi(data);
      if (
        !response ||
        !response.data ||
        (response.data && response.data?.success == 0)
      ) {
        toast.error("Report Download Fail", { duration: 2000 });

        return rejectWithValue(response);
      }

      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8",
      });

      FileSaver.saveAs(blob, data.reportName);
      toast.success("Report Downloaded Successfully", { duration: 2000 });
    } catch (error) {
      toast.error("Report Download Fail", { duration: 2000 });
      if (error && typeof error === "object" && "response" in error) {
        // @ts-expect-error: error is unknown, but we expect response property
        return rejectWithValue(error.response?.data || (error as any).message);
      }
      return rejectWithValue((error as Error).message || "Unknown error");
    }
  }
);

export const downloadOthersReportsAction = createAsyncThunk(
  "others/downloadReports",
  async (data: DownloadOthersReportsApiPayloadType, { rejectWithValue }) => {
    try {
      const response = await downloadOthersReportsApi(data);
      if (
        !response ||
        !response.data ||
        (response.data && response.data?.success == 0)
      ) {
        toast.error("Report Download Fail", { duration: 2000 });

        return rejectWithValue(response);
      }
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8",
      });

      FileSaver.saveAs(blob, data.reportName);
      toast.success("Report Downloaded Successfully", { duration: 2000 });
    } catch (error) {
      toast.error("Report Download Fail", { duration: 2000 });
      if (error && typeof error === "object" && "response" in error) {
        // @ts-expect-error: error is unknown, but we expect response property
        return rejectWithValue(error.response?.data || (error as any).message);
      }
      return rejectWithValue((error as Error).message || "Unknown error");
    }
  }
);

export const invoicingAdvanceLockEntryAction = createAsyncThunk(
  "invoicingAdvance/post/locking-entry",
  async (data: InvoicingAdvanceLockEntryApiPayloadType) => {
    const response = await invoicingAdvanceLockEntryApi(data);
    return response.data;
  }
);

export const getAllMappedClientColumnListAction = createAsyncThunk(
  "invoicingAdvance/getAllMappedClientColumnList",
  async (data: GetAllMappedClientColumnsApiPayloadType) => {
    const response = await getAllMappedClientColumnListApi(data);
    return response.data;
  }
);

export const postInvoicingAdvanceOCRAction = createAsyncThunk(
  "invoicingAdvance/getSingleInvoiceDetailsFromOcrAction",
  async (data: PostInvoicingAdvanceOCRApiPayloadType) => {
    const response = await postInvoicingAdvanceOCRApi(data);
    return response.data;
  }
);

export const addInvoicingAdvanceAction = createAsyncThunk(
  "invoicingAdvance/addInvoice",
  async (data: AddInvoicingAdvanceApiPayloadType) => {
    const response = await addInvoicingAdvanceApi(data);
    return response.data;
  }
);

export const getSingleInvoiceEntryAction = createAsyncThunk(
  "invoicingAdvance/getSingleInvoiceDetails",
  async (data: GetSingleInvoiceEntryApiPayloadType) => {
    const response = await getSingleInvoiceEntryApi(data);
    return response.data;
  }
);

export const approveInvoiceAction = createAsyncThunk(
  `approve/customer/invoice`,
  async (data: ApproveInvoiceApiPayloadType) => {
    const response = await invoiceApprovalApi(data);
    return response.data;
  }
);

export const invoiceDownloadDetailsAction = createAsyncThunk(
  "/invoicingAdvance/customer/invoice/download",
  async (data: GetCommentApiType) => {
    const response = await invoiceDownloadDetailsApi(data);
    return response.data;
  }
);

export const deleteInvoiceEntryAction = createAsyncThunk(
  `/invoicingAdvance/deleteInvoice`,
  async (data: DeleteInvoiceEntryPayloadType) => {
    const response = await deleteInvoiceEntryApi(data);
    return response.data;
  }
);

export const updateInvoicingAdvanceAction = createAsyncThunk(
  "invoicingAdvance/UpdateInvoice",
  async (data: UpdateInvoicingAdvanceApiPayloadType) => {
    const response = await updateInvoicingAdvanceApi(data);
    return response.data;
  }
);

export const getBulkUploadHistoryAction = createAsyncThunk(
  "invoicingAdvance/bulkUploadHistory",
  async (data: GetBulkUploadHistoryPayloadType) => {
    const response = await getBulkUploadHistoryDataApi(data);
    return { data: response.data, offset: data.params.offset };
  }
);

export const bulkUploadActionOther = createAsyncThunk(
  `invoicingAdvance/upload/others/invoice`,
  async (data: BulkUploadApiType) => {
    const response = await bulkUploadOtherApi(data);
    if (response?.data?.success === 0 && response?.data?.error) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    if (response?.data?.success && response?.data?.error_docs_count > 0) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    return response.data;
  }
);

export const bulkUploadActionOtherSuspense = createAsyncThunk(
  `invoicingAdvance/upload/Suspense/others/invoice`,
  async (data: BulkUploadApiType) => {
    const response = await bulkUploadOtherSuspenseApi(data);
    if (response?.data?.success === 0 && response?.data?.error) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    if (response?.data?.success && response?.data?.error_docs_count > 0) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    return response.data;
  }
);

export const bulkUploadActionRevenue = createAsyncThunk(
  `invoicingAdvance/upload/revenues/invoice`,
  async (data: BulkUploadApiType) => {
    const response = await bulkUploadRevenueApi(data);
    if (response?.data?.success === 0 && response?.data?.error) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    if (response?.data?.success && response?.data?.error_docs_count > 0) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    return response.data;
  }
);

export const bulkUploadActionExpenses = createAsyncThunk(
  `invoicingAdvance/upload/expenses/invoice`,
  async (data: BulkUploadApiType) => {
    const response = await bulkUploadExpensesApi(data);
    if (response?.data?.success === 0 && response?.data?.error) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    if (response?.data?.success && response?.data?.error_docs_count > 0) {
      toast.error("Bulk Upload Failed", { duration: 2000 });
    }
    return response.data;
  }
);

export const reviewEwayBillAction = createAsyncThunk(
  "invoicingAdvance/review/eway-bill",
  async (data: ReviewEWayBillPayloadApi) => {
    const response = await ReviewEWayBillApi(data);
    return response.data;
  }
);

export const generateEWayBillAction = createAsyncThunk(
  "invoicingAdvance/generate/eway-bill",
  async (data: GenerateEWayBillPayloadType) => {
    const response = await generateEWayBillApi(data);
    return response.data;
  }
);

export const cancelEWayBillAction = createAsyncThunk(
  "invoicingAdvance/cancel-e-way-bill",
  async (data: EWayBillCancelPayloadType) => {
    const response = await eWayBillCancelApi(data);
    return response.data;
  }
);

export const postExtendEWayBillAction = createAsyncThunk(
  "invoicingAdvance/expend/eway-bill",
  async (data: ExtendEWayBillPayloadType) => {
    const response = await extendEWayBillApi(data);
    return response.data;
  }
);

export const checkDistanceCountAction = createAsyncThunk(
  "invoicingAdvance/distance",
  async (data: DistanceCountPayloadType) => {
    const response = await checkDistanceCountApi(data);
    return response;
  }
);

export const postEwayBillAuthenticationAction = createAsyncThunk(
  "invoicingAdvance/post/e-way-bill/authentication",
  async (data: EinvoiceAuthenticationDataPayloadType) => {
    const response = await eWayBillAuthenticationPostApi(data);
    return response.data;
  }
);

export const updateVehicleEWayBillDetails = createAsyncThunk(
  "invoicingAdvance/update/e-way-bill",
  async (data: UpdateEWayBillPayloadType) => {
    const response = await updateVehicleEWayBillDetailsApi(data);
    return response.data;
  }
);
export const updateTransporterEWayBillDetails = createAsyncThunk(
  "invoicingAdvance/update/transporter/e-way-bill",
  async (data: UpdateTrasporterEWayBillPayloadType) => {
    const response = await updateTransporterEWayBillDetailsApi(data);
    return response.data;
  }
);

export const checkDuplicateInvoiceEntryAction = createAsyncThunk(
  "/invoicingAdvance/duplicate/invoice",
  async (data: DuplicateEntriesPayloadType) => {
    const response = await checkDuplicateInvoiceEntryApi(data);
    return response.data;
  }
);

export const downloadBulkUploadTemplate = createAsyncThunk(
  "invoicingAdvance/download/bulkUploadTemplate",
  async (data: GetAllMappedClientColumnsApiPayloadType, thunkApi) => {
    const response = await getAllMappedClientColumnListApi(data);

    try {
      const state = thunkApi.getState();
      const activeTab = (state as any).invoicingAdvance.activeAddInvoiceType;
      const { success, result } = response.data;
      if (success !== 1) return response.data;

      const columnList =
        activeTab === "expenses" ? result?.expenses : result?.revenues;

      const sections = ["primary", "item", "payment"];

      const getCsvColumns = (key: string) => {
        const list = columnList?.[key];
        if (!Array.isArray(list)) return [];

        return list
          .filter(checkComparison)
          .map((item: SingleColumnType) => item?.name)
          .filter(Boolean);
      };

      const csvData = sections.map(getCsvColumns);
      // Add "Document Number" at the beginning of primary section
      if (csvData[0]?.length) {
        csvData[0].unshift("Document Number");
      }

      const csvColumns = csvData.flat();
      if (activeTab === "expenses") {
        csvColumns.push("MONTH IN GSTR 3B");
      }
      const blob = new Blob([csvColumns.join(",")], {
        type: "text/csv;charset=utf-8;",
      });
      FileSaver.saveAs(blob, "template.csv");
      toast.success("Template Downloaded Successfully", {
        duration: 2000,
      });
    } catch {
      toast.error("Template Download Fail", {
        duration: 2000,
      });
    }
    return response.data;
  }
);

export const getAllOtherInvoicesListAction = createAsyncThunk(
  "/invoicingAdvance/getAllOtherInvoicesList",
  async (data: GetAllOtherInvoicesListApiPayloadType) => {
    const response = await getAllOtherInvoicesListApi(data);
    return { data: response.data, offset: data.params.offset };
  }
);

export const deleteOtherInvoiceEntryAction = createAsyncThunk(
  `/invoicingAdvance/deleteOtherInvoice`,
  async (data: DeleteOtherInvoicesApiPayloadType) => {
    const response = await deleteOtherInvoiceApi(data);
    return response.data;
  }
);

export const getOthersInvoiceHistoryDataAction = createAsyncThunk(
  "invoicingAdvance/others/history/invoice",
  async (data: OtherHistoryPayloadApiType) => {
    const response = await getOthersInvoiceHistoryApi(data);
    return { data: response.data, offset: data.params.offset };
  }
);

export const sendOverdueEmailApiAction = createAsyncThunk(
  "invoicingAdvance/OverdueEmail",
  async (data: SendOverdueEmailPayloadApiType) => {
    const response = await sendOverdueEmailApi(data);
    return response.data;
  }
);

export const addOtherInvoiceAction = createAsyncThunk(
  "invoicingAdvance/addOtherInvoice",
  async (data: AddOtherInvoiceApiPayloadType) => {
    const response = await addOtherInvoiceGenerationApi(data);
    return response.data;
  }
);

export const updateOtherInvoiceAction = createAsyncThunk(
  "invoicingAdvance/updateOtherInvoice",
  async (data: UpdateOtherInvoiceApiPayloadType) => {
    const response = await updateOtherInvoiceApi(data);
    return response.data;
  }
);

export const getSingleOtherInvoiceEntryAction = createAsyncThunk(
  "invoicingAdvance/getOtherInvoiceDetail",
  async (data: GetSingleOtherInvoiceDetailsPayloadType) => {
    const response = await getSingleOtherInvoiceDetailsApi(data);
    return response.data;
  }
);

export const getGstrTwoATwoBComparePayloadAction = createAsyncThunk(
  "get/add/gstr2a2b/compare/expense",
  async (data: GetGstrTwoATwoBInvoicePayload) => {
    const response = await getGstr2a2bComparePayloadApi(data);
    return response.data;
  }
);
export const getUploadedBankStatementAction = createAsyncThunk(
  "invoicingAdvance/getUploadedBankStatement",
  async (data: GetUploadedBankStatementPayload) => {
    const response = await getUploadedBankStatementApi(data);
    return response.data;
  }
);
export const getAllPaymentLedgersListAction = createAsyncThunk(
  "invoicingAdvance/getAllPaymentLedgersList",
  async (data: GetAllLedgersListPayloadType) => {
    const response = await getAllPaymentLedgersListApi(data);
    return response.data;
  }
);
export const uploadBankStatementAction = createAsyncThunk(
  "invoicingAdvance/uploadBankStatement",
  async (payload: { token: string | null; formData: FormData }) => {
    const response = await uploadBankStatementApi(payload);
    return response.data;
  }
);

export const getUploadedBankStatementTransactionList = createAsyncThunk(
  "get/uploadedBankStatementList",
  async (data: GetBankStatementsTransactionsListPayload) => {
    const response = await getUploadedBankStatementTransactionApi(data);
    return response.data;
  }
);
export const getUploadedBankStatementTransactionCommentList = createAsyncThunk(
  "get/uploadedBankStatementCommentList",
  async (data: GetBankStatementsTransactionsCommentListPayload) => {
    const response = await getUploadedBankStatementTransactionCommentApi(data);
    return response.data;
  }
);
export const postTransactionCommentList = createAsyncThunk(
  "get/postTransactionCommentList",
  async (data: PostTransactionsCommentListPayload) => {
    const response = await postTransactionCommentApi(data);
    return response.data;
  }
);

export const allocateBankTransactionToOtherInvoice = createAsyncThunk(
  "get/allocateBankTransactionToOtherInvoice",
  async (data: CreateOthersInvoiceAndAllocatePayload) => {
    const response = await allocateBankTransactionToOtherInvoiceApi(data);
    return response.data;
  }
);

export const postMultipleBankTransactionAction = createAsyncThunk(
  "postMultipleBankTransaction",
  async (data: PostMultipleBankTransactionPayload) => {
    const response = await postMultipleBankTransactionApi(data);
    return response.data;
  }
);

export const refreshBankStatementSuggestionsList = createAsyncThunk(
  "post/refreshBankTransactionDetails",
  async (data: RefreshBankStatementSuggestionsPayload) => {
    const response = await refreshBankStatementSuggestionsApi(data);
    return response.data;
  }
);

export const bankStatementTransactionFileUploadAction = createAsyncThunk(
  "post/bankStatementFileUpload",
  async (data: BankStatementTransactionFileUploadPayload) => {
    const response = await bankStatementTransactionFileUploadApi(data);
    return response.data;
  }
);

export const getOverdueInvoiceReminderEmailTimelineAction = createAsyncThunk(
  "get/overdueInvoiceTimeline",
  async (data: InvoiceOverdueEmailTimelinePayload) => {
    const response = await getOverdueInvoiceReminderEmailTimeline(data);
    return response.data;
  }
);

export const lockUnlockInvoiceAction = createAsyncThunk(
  "post/lockUnlockInvoice",
  async (data: LockUnlockInvoicePayloadType) => {
    const response = await lockUnlockInvoiceApi(data);
    return response.data;
  }
);
